import useManageGls, {
  IDataType as IManageGlsDataType,
} from './administration/useManageGls'
import useManageLocationGroups, {
  IDataType as IManageLocationGroupsDataType,
} from './administration/useManageLocationGroups'
import useManageLocations, {
  IDataType as IManageLocationsDataType,
} from './administration/useManageLocations'
import usePnlConfig, {
  IDataType as IPnlConfigDataType,
} from './administration/usePnlConfig'
import useDate, {
  IDataType as IDateDataType,
  IOptionType as IDateOptionType,
} from './date'
import useAllStores, {
  IDataType as IAllStoresDataType,
  IOptionType as IAllStoresOptionType,
} from './useAllStores'
import useAllStoresV2, {
  IDataType as IAllStoresV2DataType,
  IOptionType as IAllStoresV2OptionType,
} from './useAllStoresV2'
import useCorporateGroup, {
  IDataType as ICorporateGroupDataType,
} from './useCorporateGroup'
import useDeliveryDayParts, {
  IDataType as IDeliveryDayPartsType,
} from './useDeliveryDayParts'
import useDeliveryKpiType, {
  IDataType as IDeliveryKpiTypeDataType,
} from './useDeliveryKpiType'
import useDiscountType, {
  IDataType as IDiscountTypeDataType,
} from './useDiscountType'
import useInputValue, {
  IDataType as IInputValueDataType,
  IOptionType as IInputValueOptionType,
} from './useInputValue'
import useInterval, { IDataType as IIntervalDataType } from './useInterval'
import useItemByDaypartColummFilter, {
  IDataType as IItemByDaypartColumnFilterType,
} from './useItemByDaypartColumnFilter'
import useItemOrCategory, {
  IDataType as IItemOrCategoryDataType,
  IOptionType as IItemOrCategoryOptionType,
} from './useItemOrCategory'
import useItemOrCategoryV2, {
  IDataType as IItemOrCategoryV2DataType,
  IOptionType as IItemOrCategoryV2OptionType,
} from './useItemOrCategoryV2'
import useLastTimeRange, {
  IDataType as ILastTimeRangeDataType,
  IOptionType as ILastTimeRangeOptionType,
} from './useLastTimeRange'
import usePnl, {
  IDataType as IPnlDataType,
  IOptionType as IPnlOptionType,
} from './usePnl'
import usePnlRankings, {
  IDataType as IPnlRankingsDataType,
  IOptionType as IPnlRankingsOptionType,
} from './usePnlRankings'
import useRankings, {
  IDataType as IRankingsDataType,
  IOptionType as IRankingsOptionType,
} from './useRankings'
import useRevenueCenterSales, {
  IDataType as IRevenueCenterSalesType,
} from './useRevenueCenterSales'
import useSelectOptions, {
  IDataType as ISelectOptionsDataType,
  IOptionType as ISelectOptionsOptionType,
} from './useSelectOptions'
import useTimeBetween, {
  IDataType as ITimeBetweenDataType,
} from './useTimeBetween'
import useTrack, { IDataType as ITrackDataType } from './useTrack'

export type IVariablesType =
  | 'track'
  | 'date'
  | ({ type: 'date' } & IDateOptionType)
  | 'allStores'
  | ({ type: 'allStores' } & IAllStoresOptionType)
  | 'allStoresV2'
  | ({ type: 'allStoresV2' } & IAllStoresV2OptionType)
  | 'corporateGroup'
  | ({ type: 'items' } & IItemOrCategoryOptionType)
  | ({ type: 'itemsV2' } & IItemOrCategoryV2OptionType)
  | 'interval'
  | 'timeBetween'
  | 'itemByDaypartColumnFilter'
  | 'discountType'
  | 'lastTimeRange'
  | ({ type: 'lastTimeRange' } & ILastTimeRangeOptionType)
  | 'deliveryKpiType'
  | 'deliveryDayParts'
  | 'revenueCenterSales'
  | ({ type: 'rankings' } & IRankingsOptionType)
  | ({ type: 'inputValue' } & IInputValueOptionType)
  | 'manageLocations'
  | 'manageLocationGroups'
  | 'manageGls'
  | ({ type: 'pnl' } & IPnlOptionType)
  | ({ type: 'pnlRankings' } & IPnlRankingsOptionType)
  | ({ type: 'selectOptions' } & ISelectOptionsOptionType)
  | 'pnlConfig'

export type IDataType = IDateDataType &
  IAllStoresDataType &
  IAllStoresV2DataType &
  ITrackDataType &
  ICorporateGroupDataType &
  IItemOrCategoryDataType &
  IItemOrCategoryV2DataType &
  IIntervalDataType &
  ITimeBetweenDataType &
  IItemByDaypartColumnFilterType &
  IDiscountTypeDataType &
  ILastTimeRangeDataType &
  IDeliveryKpiTypeDataType &
  IDeliveryDayPartsType &
  IRevenueCenterSalesType &
  IRankingsDataType &
  IInputValueDataType &
  IManageLocationsDataType &
  IManageLocationGroupsDataType &
  IManageGlsDataType &
  IPnlDataType &
  IPnlRankingsDataType &
  ISelectOptionsDataType &
  IPnlConfigDataType

export const hooks = [
  ['track', useTrack],
  ['date', useDate],
  ['allStores', useAllStores],
  ['allStoresV2', useAllStoresV2],
  ['corporateGroup', useCorporateGroup],
  ['items', useItemOrCategory],
  ['itemsV2', useItemOrCategoryV2],
  ['interval', useInterval],
  ['timeBetween', useTimeBetween],
  ['itemByDaypartColumnFilter', useItemByDaypartColummFilter],
  ['discountType', useDiscountType],
  ['lastTimeRange', useLastTimeRange],
  ['deliveryKpiType', useDeliveryKpiType],
  ['deliveryDayParts', useDeliveryDayParts],
  ['revenueCenterSales', useRevenueCenterSales],
  ['rankings', useRankings],
  ['inputValue', useInputValue],
  ['manageLocations', useManageLocations],
  ['manageLocationGroups', useManageLocationGroups],
  ['manageGls', useManageGls],
  ['pnl', usePnl],
  ['pnlRankings', usePnlRankings],
  ['selectOptions', useSelectOptions],
  ['pnlConfig', usePnlConfig],
] as const
